import { FuelButton } from '@frete.com/fuel-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAmplitude from '@hooks/useAmplitude';
import { ActionConfirmHiringProps } from './ActionConfirmHiringTypes';
import * as Styled from './ActionConfirmHiringStyles';

const COMPANY_NCA_MANUALLY = 'company:nca:manually';
const NEGOTIATION_NCA_AUTOMATIC = 'chat:negotiation:automatic';
const TRUCKER_DEPOSIT_FEE = 'trucker:deposit:fee';
const GR_JOURNEY = 'gr:fretebras';

function ActionConfirmHiring({
  fullWidth = false,
  proposalId,
  createdBy,
}: ActionConfirmHiringProps) {
  const { amplitudeEvent } = useAmplitude();
  const navigate = useNavigate();

  const isAllowedActionsTypes = [
    TRUCKER_DEPOSIT_FEE,
    COMPANY_NCA_MANUALLY,
    GR_JOURNEY,
    NEGOTIATION_NCA_AUTOMATIC,
  ];

  if (!isAllowedActionsTypes.includes(createdBy)) {
    return null;
  }

  const isShowConfirmation =
    createdBy !== COMPANY_NCA_MANUALLY &&
    createdBy !== NEGOTIATION_NCA_AUTOMATIC;

  function handleClickConfirm(id: ActionConfirmHiringProps['proposalId']) {
    amplitudeEvent('proposal_list_clicked_button', {
      source: 'button-confirmar',
    });

    navigate(`pre-viagem/${id}/aceite`);
  }

  function handleClickRejected(id: ActionConfirmHiringProps['proposalId']) {
    amplitudeEvent('proposal_list_clicked_button', {
      source: 'button-descartar',
      createdBy,
    });

    navigate(`pre-viagem/${id}/recusa`);
  }

  return (
    <Styled.Wrapper>
      <FuelButton
        data-testid="list-cancelar-button"
        variant="tertiary"
        onClick={() => handleClickRejected(proposalId)}
        size={fullWidth ? 'medium' : 'small'}
        fullWidth={fullWidth}
      >
        Cancelar
      </FuelButton>

      {isShowConfirmation && (
        <FuelButton
          data-testid="list-confirmar-button"
          variant="secondary"
          onClick={() => handleClickConfirm(proposalId)}
          size={fullWidth ? 'medium' : 'small'}
          fullWidth={fullWidth}
        >
          Confirmar
        </FuelButton>
      )}
    </Styled.Wrapper>
  );
}

export default ActionConfirmHiring;
